var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ADMIN_ROLE } from '@careapp/core';
import { createSelector } from 'reselect';
import * as actions from '../actions/index';
export var LOCAL_STORAGE_AUTH_KEY = 'careapp.auth';
var initialState = {
    loading: false,
    resetPassword: false,
    error: '',
    ready: false
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actions.REQUEST_AUTH_LOGIN:
        case actions.REQUEST_LOGGED_IN_USER:
        case actions.REQUEST_AUTH_FORGOT_PASSWORD: {
            return __assign({}, state, { loading: true, resetPassword: false });
        }
        case actions.AUTH_RESET_ERRORS: {
            return __assign({}, state, { error: '', resetPassword: false });
        }
        case actions.REQUEST_AUTH_LOGOUT: {
            return __assign({}, state, { auth: null, loading: true });
        }
        case actions.RESPONSE_SUCCESS_AUTH_FORGOT_PASSWORD: {
            return __assign({}, state, { auth: null, loading: false, resetPassword: true, error: '' });
        }
        case actions.RESPONSE_SUCCESS_UPDATED_PROFILE:
        case actions.RESPONSE_SUCCESS_SAVE_PROFILE: {
            return __assign({}, state, { user: action.payload, loading: false });
        }
        case actions.APPLICATION_AUTHORIZED: {
            if (action.payload.user) {
                return __assign({}, state, { user: action.payload.user, ready: true });
            }
            return __assign({}, state, { ready: true });
        }
        case actions.RESPONSE_SUCCESS_USER_ROLES:
            return __assign({}, state, { roles: action.payload });
        case actions.RESPONSE_SUCCESS_AUTH_REFRESH:
        case actions.RESPONSE_SUCCESS_AUTH_LOGIN: {
            var newState = __assign({}, state, { loading: false, error: '', auth: __assign({}, action.payload, { created: new Date(), dirty: false }) });
            return newState;
        }
        case actions.HYDRATE_AUTH: {
            return __assign({}, state, { auth: __assign({}, (state.auth || {}), action.payload, { dirty: true, date: new Date() }) });
        }
        case actions.RESPONSE_FAIL_AUTH_LOGOUT:
        case actions.RESPONSE_SUCCESS_AUTH_LOGOUT: {
            return initialState;
        }
        case actions.RESPONSE_FAIL_AUTH_LOGIN:
        case actions.RESPONSE_FAIL_AUTH_FORGOT_PASSWORD: {
            var error = action.payload.code || action.payload;
            return __assign({}, state, { auth: null, loading: false, error: error });
        }
        case actions.RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
export var createSelectors = function (rootReducer) { return ({
    getLoggedIn: createSelector(rootReducer, function (state) { return state.auth && typeof state.auth.id === 'string'; }),
    getAuth: createSelector(rootReducer, function (state) { return state.auth; }),
    getAuthToken: createSelector(rootReducer, function (state) { return (state.auth ? state.auth.id : null); }),
    getError: createSelector(rootReducer, function (state) { return state.error; }),
    getLoading: createSelector(rootReducer, function (state) { return state.loading; }),
    getPersisted: createSelector(rootReducer, function (state) {
        var persisted = __assign({}, state);
        delete persisted.ready;
        delete persisted.loading;
        return persisted;
    }),
    getResetPassword: createSelector(rootReducer, function (state) { return state.resetPassword; }),
    getLoggedInUser: createSelector(rootReducer, function (state) { return state.user; }),
    getRoles: createSelector(rootReducer, function (state) { return state.roles; }),
    isAdmin: createSelector(rootReducer, function (state) { return state.roles && !!state.roles.find(function (value) { return value === ADMIN_ROLE; }); }),
    isReady: createSelector(rootReducer, function (state) { return (state ? state.ready : false); }),
    getAuthLinkQueryParams: createSelector(rootReducer, function (state) {
        if (state.auth && state.auth.userId && state.auth.id) {
            return "accessToken=" + state.auth.id + "&userId=" + state.auth.userId;
        }
        else {
            return '';
        }
    })
}); };
